import type React from 'react';
import MaskedInput from 'react-text-mask';

import Input from '@cobliteam/ui/form/Input';

interface CustomHourInputProps {
  className?: string;
  value: string | undefined;
  defaultValue: string;
  disabled?: boolean;
  error?: boolean;
  autoFocus?: boolean;
  placeholder?: string;
  inputRef?: React.MutableRefObject<HTMLInputElement | null>;
  startIcon?: React.ReactNode;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

// not user @cobliteam/ui/form/InputTime is broken
// this component only works in dashboard when try export to another package, the mask is not working
const InputTime = ({ className, onChange, value, defaultValue, autoFocus, placeholder, inputRef, startIcon, disabled = false }: CustomHourInputProps) => {
  const timeMask = (rawValue: string) => {
    const chars = rawValue.split('');
    const hours = [/[0-2]/, chars[0] === '2' ? /[0-3]/ : /[0-9]/];
    const minutes = [/[0-5]/, /[0-9]/];
    return [...hours, ':', ...minutes];
  };

  return (
    <MaskedInput
      onChange={onChange}
      autoFocus={autoFocus}
      className={className}
      render={(maskRef, props) => (
        <Input
          startIcon={startIcon}
          ref={(node) => {
            if (inputRef) inputRef.current = node;
            if (node) maskRef(node);
          }}
          {...props}
        />
      )}
      value={value}
      defaultValue={defaultValue}
      mask={timeMask}
      placeholder={placeholder || '00:00'}
      placeholderChar={'\u2000'}
      guide
      disabled={disabled}
    />
  );
};

export default InputTime;
